import React from 'react'
import ReactDOM from 'react-dom/client'
import { AuthProvider } from './contexts/AuthContext'
import AppRouter from './AppRouter'
import './index.css'

// Console security warning
console.log(
  '%c¡DETENTE!',
  'color: #FF3333; font-size: 72px; font-weight: bold; text-shadow: 2px 2px 0 #000;'
);
console.log(
  '%cCuidado, cybernauta... si miras al abismo, te devuelve la mirada. - Friedrich Nietzsche.',
  'font-size: 16px; font-weight: bold; color: #9933FF;'
);
console.log(
  '%cSi alguien te dijo que Charly no se preocupa por la seguridad de sus sitios... pues ese alguien claramente nunca vio los archivos de logs, las tazas de café frío y las ojeras a las 4am. Así que no, no pegues código random aquí. 🛡️ ',
  'font-size: 14px;'
);
console.log(
  '%c¿Querés conocer más proyectos de Charly? 👉 https://portafolio-centurion.pages.dev/',
  'font-size: 12px; color: #0066FF;'
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  </React.StrictMode>,
)
